import { useMemo, useState } from 'react'
import { Text, useWindowSize } from '../../../../modules/Dashboard'
import { usePredictContext } from '../../context/PredictContextProvider'
import CardLayout from '../../../../components/layouts/CardLayout'
import { useNavigate, useParams } from 'react-router-dom'
import PairSelect from '../../utils/PairSelect/PairSelect'
import ResponseTypeSelect from '../../utils/TypeSelect'
import TimeFrameSelect from '../../utils/TimeFrameSelect'
import useTimeFrame, { getFrameLabel } from '../../utils/TimeFrameSelect/core'
import { MOBILE_SIZE } from '../../../../core/constants/common'
import RPairSelect from '../../utils/PairSelect/RPairSelect'
import RTimeFrameSelect from '../../utils/TimeFrameSelect/RTimeframSelect'

const NewAnalyze = () => {
    const { width } = useWindowSize()
    const { ticker, timeFrame } = usePredictContext()
    const { shouldRenderTimeFrame } = useTimeFrame()
    const navigate = useNavigate()
    const { mode, market } = useParams()
    const [modalOpen, setModalOpen] = useState(false)

    const isValid = useMemo(() => {
        if (!ticker) return false;
        if (!!shouldRenderTimeFrame() && !timeFrame) return false;
        return true;
    }, [ticker, timeFrame, shouldRenderTimeFrame])


    const handleSelectMethod = () => {
        setModalOpen(false)
        navigate(`/analyze/${mode}/${market}?step=result`)
    }

    const handleStartAnalyzing = () => {
        if (mode === 'fastscans') handleSelectMethod()
        else setModalOpen(true)
    }


    return (
        <>
            <CardLayout className={`!p-0 !h-full !border-none`}>
                <div className='p-4 md:p-6 md:px-8 flex flex-col items-start justify-start h-full w-full gap-4 relative z-20 mx-auto'>
                    {
                        width <= MOBILE_SIZE ?
                            <RPairSelect /> :
                            <PairSelect />
                    }
                    <div className='my-1' />
                    {
                        width >= MOBILE_SIZE ?
                            <TimeFrameSelect /> :
                            <RTimeFrameSelect />
                    }
                    <div className='my-1' />
                    <div className={`${!ticker && "hidden"} bg-gradient-to-bl from-[#9810FA1A] to-[#FF69001A] border border-[#AD46FF4D] p-7 rounded-2xl w-full`}>
                        <div className='flex flex-col gap-3 items-center'>
                            <div className='flex justify-between items-start gap-4 w-full'>
                                <div className='flex flex-col gap-2'>
                                    <Text tid='selected-pair' className={` md:text-lg ${!ticker && "hidden"}`} />
                                    <div className='flex items-center gap-3'>
                                        {
                                            !!timeFrame &&
                                            <span className='inline'>
                                                <Text tid='timeframe' className='inline text-[#DAB2FF]' />
                                                :{" "}
                                                <span className='text-[#FF8904]'>{timeFrame}</span>
                                            </span>
                                        }
                                    </div>
                                </div>
                                <span className='text-xl lg:text-2xl'>
                                    {ticker}
                                </span>
                            </div>
                            <button
                                onClick={handleStartAnalyzing}
                                className={`w-full flex justify-center items-center p-2 md:p-4 rounded-full md:rounded-xl  ${isValid ? "cursor-pointer bg-gradient-to-r from-[#9810FA] to-[#FF6900]" : "bg-primaryOrange/30 cursor-not-allowed"}`} >
                                <span className='inline'>
                                    <span tid="start-analyze" className='inline' >⚡</span>
                                    <Text tid="start-analyze" className='md:text-lg inline mx-1' />
                                    <span tid="start-analyze" className='md:text-lg inline' >→</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </CardLayout>
            <ResponseTypeSelect onSelect={handleSelectMethod} open={modalOpen} onClose={() => { setModalOpen(false) }} />
        </>
    )
}

export default NewAnalyze